"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Padding = function Padding(props) {
  var _classnames;

  var p = props.p,
      px = props.px,
      py = props.py,
      className = props.className,
      children = props.children;
  var spacerClass = (0, _classnames2["default"])((_classnames = {}, _classnames["p-" + p] = p !== false, _classnames["px-" + px] = px !== false, _classnames["py-" + py] = py !== false, _classnames), className);
  return _react["default"].createElement("div", {
    className: spacerClass
  }, children);
};

Padding.propTypes = {
  className: _propTypes["default"].string,
  p: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number]),
  px: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number]),
  py: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number])
};
Padding.defaultProps = {
  className: '',
  p: false,
  px: false,
  py: false
};
Padding.displayName = 'Padding';

var _default = _react["default"].memo(Padding);

exports["default"] = _default;